// Break session id out to its own module so it persists across hot reloads
// Otherwise you might lock out yourself, which would be annoying!
// It doesn't need to be updated, it just distinguishes different clients
// (browser tabs, basically).
// Just generating a new id on load means that you can lock yourself out
// just by reloading the page, so persist in sessionStorage, but only on
// navigation, so that duplicating the tab gives a new id too.
const storageKey = "module-session-id";

export const sessionId = sessionStorage.getItem(storageKey) ?? crypto.randomUUID();

sessionStorage.removeItem(storageKey);

window.addEventListener("unload", () => {
  sessionStorage.setItem(storageKey, sessionId);
});
